import { store } from '../store/store'
import { SDK_IDS, SDK_ID_MASTERCARD } from '../utils/constant'
import sharedService from '../utils/shared-service'

const responseParameters = {

  getMethodParameters ({ methodName, finalResponse }) {
    if (responseParameters[methodName + 'Response']) {
      return responseParameters[methodName + 'Response']({ finalResponse })
    } else {
      return finalResponse
    }
  },

  bootstrapResponse ({ finalResponse }) {
    let selectedSdks = store.getters.loadedSDKs
    Object.keys(finalResponse).forEach(sdkKey => {
      if (finalResponse[sdkKey].loaded) {
        selectedSdks.push(sdkKey)
      }
    })
    store.commit('loadedSDKs', [...new Set(selectedSdks)])
    return finalResponse
  },

  isRecognizedResponse ({ finalResponse }) {
    let isRecognised = false
    let combinedIdTokens = []
    Object.keys(finalResponse).forEach(sdkName => {
      if (finalResponse[sdkName].status === 'fulfilled' && finalResponse[sdkName].response.recognized) {
        isRecognised = true
        combinedIdTokens.push(...finalResponse[sdkName].response['idTokens'])
      }
    })
    const result = {
      recognized: isRecognised,
      idTokens: combinedIdTokens
    }
    if (store.getters.jwtOnOff === 'on') {
      return sharedService.getFederatedIdResult(result)
    } else {
      return result
    }
  },

  identityLookupResponse ({ finalResponse }) {
    let response = Object.assign({}, finalResponse)
    if (response[SDK_ID_MASTERCARD].response && response[SDK_ID_MASTERCARD].response.consumerPresent) {
      store.commit('setConsumerPresent', true)
    }
    let identityLookupResponse = {
      consumerPresent: false
    }
    let filteredResponse = Object.keys(response)
      .filter(key => response[key].status === 'fulfilled' && response[key].response.consumerPresent && response[key].response.lastUsedCardTimestamp)
      .reduce((arr, key) => {
        response[key]['sdkName'] = key
        arr.push(response[key])
        return arr
      }, [])
    if (filteredResponse.length > 0) {
      filteredResponse.sort((a, b) => this.sortByTimeStamp(a.response.lastUsedCardTimestamp, b.response.lastUsedCardTimestamp))
      identityLookupResponse = {
        ...filteredResponse[0].response,
        networkProcessingOTP: filteredResponse[0].sdkName
      }
    } else {
      Object.keys(SDK_IDS).some(sdkName => {
        let sdkResponse = response[sdkName] || {}
        if (sdkResponse.status === 'fulfilled' && sdkResponse.response.consumerPresent) {
          identityLookupResponse = {
            ...sdkResponse.response,
            networkProcessingOTP: sdkName
          }
          return true
        }
      })
    }
    return identityLookupResponse
  },

  authenticationMethodsLookupResponse ({ finalResponse }) {
    return this.getValueFromResponse({ finalResponse })
  },

  authenticateResponse ({ finalResponse }) {
    return this.getValueFromResponse({ finalResponse })
  },

  sortByTimeStamp (timeStamp1, timeStamp2) {
    if (timeStamp1.length === 10) {
      timeStamp1 = timeStamp1 * 1000
    }
    if (timeStamp2.length === 10) {
      timeStamp2 = timeStamp2 * 1000
    }
    return new Date(timeStamp2) - new Date(timeStamp1)
  },

  initiateIdentityValidationResponse ({ finalResponse }) {
    return this.getValueFromResponse({ finalResponse })
  },

  completeIdentityValidationResponse ({ finalResponse }) {
    return this.getValueFromResponse({ finalResponse })
  },

  getSrcProfileResponse ({ finalResponse }) {
    let combinedProfiles = { profiles: [] }
    Object.keys(finalResponse).forEach(sdkName => {
      let sdkProfiles = ((finalResponse[sdkName] || {}).response || {}).profiles || []
      if (finalResponse[sdkName].status === 'fulfilled' && sdkProfiles.length > 0) {
        sdkProfiles[0].srcCorrelationId = finalResponse[sdkName].response.srcCorrelationId
        sdkProfiles[0].network = sdkName
        combinedProfiles.profiles.push(...sdkProfiles)
      }
    })
    let sortedCards = responseParameters.getSortedCards({ combinedProfiles })
    return sortedCards
  },

  aggGetSrcProfileResponse ({ finalResponse }) {
    let combinedProfiles = Object.assign({}, finalResponse)
    let sortedCards = responseParameters.getSortedCards({ combinedProfiles })
    return sortedCards
  },

  getSortedCards ({ combinedProfiles }) {
    return combinedProfiles.profiles
      .filter(profile => profile.maskedCards)
      .reduce((cards, profile) => {
        let updatedCards = profile.maskedCards
          .map((card, i, cards) => {
            card.network = profile.network
            card.idToken = profile.authorization || profile.idToken
            card.srcCorrelationId = profile.srcCorrelationId
            return card
          })
        return [...cards, ...updatedCards]
      }, [])
      .sort((card1, card2) => {
        let cardLastUsedDate1 = card1.dateofCardLastUsed || card1.dateOfCardLastUsed || ''
        let cardLastUsedDate2 = card2.dateofCardLastUsed || card2.dateOfCardLastUsed || ''
        if (cardLastUsedDate1.length === 10) {
          cardLastUsedDate1 = cardLastUsedDate1 * 1000
        }
        if (cardLastUsedDate2.length === 10) {
          cardLastUsedDate2 = cardLastUsedDate2 * 1000
        }
        return new Date(cardLastUsedDate2) - new Date(cardLastUsedDate1)
      })
  },

  getValueFromResponse ({ finalResponse }) {
    try {
      finalResponse = Object.values(finalResponse)[0] || {}
      if (finalResponse.status === 'fulfilled') {
        return finalResponse.response
      }
      return false
    } catch (e) {
      return false
    }
  },

  aggCheckoutResponse ({ finalResponse }) {
    let srcNetwork = finalResponse.network
    let checkoutResponse = this.getValueFromResponse({ finalResponse })
    if (checkoutResponse) {
      checkoutResponse['srcNetwork'] = srcNetwork
    }
    return checkoutResponse
  },

  checkoutResponse ({ finalResponse }) {
    return this.getValueFromResponse({ finalResponse })
  },

  handleError ({ finalResponse }) {
    let errorCode = ''
    Object.keys(finalResponse).some(sdkId => {
      if (finalResponse[sdkId].status === 'rejected') {
        errorCode = this.getErrorCode(finalResponse[sdkId].response || finalResponse[sdkId].error)
        return true
      }
    })
    return errorCode
  },

  getErrorCode (error) {
    if (error.error) {
      error = error.error
    } else if (typeof error.reason === 'object') {
      error = error.reason
    }
    return error.reason || error.reasonCode || ''
  }
}
export default responseParameters
